import type { TFunction } from 'i18next'

import { UploadParkingCsvResponse } from '@/api/parking-management'

// Note: pluralisation goes through i18next's own `_one`/`_other` key suffixes rather
// than src/utils/intl/plural, so translators get the plural categories their locale
// actually needs (French has different rules than English, and the translation
// pipeline derives the forms from the key suffixes).
export const getParkingCsvUploadMessage = (
  t: TFunction<['parking-management']>,
  { created, skipped, skippedDuplicate, unassigned }: UploadParkingCsvResponse,
): string => {
  // Note: annotated because each t() call returns its own narrow plural-literal type;
  // without it the array is inferred from the first element and the pushes below fail.
  const sentences: string[] = [
    t('parking-management:page.uploadCsvPopup.created', { count: created }),
  ]

  if (unassigned > 0) {
    sentences.push(t('parking-management:page.uploadCsvPopup.unassigned', { count: unassigned }))
  }

  if (skipped > 0) {
    sentences.push(t('parking-management:page.uploadCsvPopup.skippedMissing', { count: skipped }))
  }

  if (skippedDuplicate > 0) {
    sentences.push(
      t('parking-management:page.uploadCsvPopup.skippedDuplicate', { count: skippedDuplicate }),
    )
  }

  return sentences.join(' ')
}
